<div class="page-wrapper"
     [elementHeight]="'app'"
     style="overflow:clip;">

    <app-busy-state></app-busy-state>

    <router-app-busy-state></router-app-busy-state>

    <!-- Overlay for photoswipe lightbox opening loader -->
    <i class="top-50 left-50 icon-loading ng-hide photoswipe-loader"
       style="position: fixed;z-index:9999;"></i>

    <div class="page-container">
        <page-header #pageHeader
                     [offCanvasState]="offCanvasState"></page-header>

        @if (hasHeader) {
        <div [class.page-content]="hasPageContentClass">
            <!-- [@routerAnimation]="getRouteAnimation(outlet)" -->
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
        }

        <ng-container *afterContentInit="'router'">

            <!-- page footer -->
            <page-footer class="block p-b-8"
                         *ifNotCheckoutProcess
                         [elementHeight]="'page-footer-wrapper'"></page-footer>

            <!-- off canvas menu -->
            <off-canvas-menu #offCanvas
                             [offCanvasState]="offCanvasState"
                             class="ng-hide ng-hide-animate off-canvas c-9-m m-b-0 m-r-0"
                             *ifSize="'MS'"></off-canvas-menu>
        </ng-container>

        <div class="main-overlay"></div>
    </div>
</div>
